import { useCallback, useEffect, useRef, useState } from 'react';

import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Column } from 'primereact/column';
// import { confirmDialog } from 'primereact/confirmdialog';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';

import Loading from '../../../components/Loading';
import Menu from '../../../components/Menu';

import api from '../../../services/api';

const initialState = {
    id: null,
    codigo: '',
    descricao: '',
    perda_metragem_por_rolo: ''
};

export const CadastroResiduo = () => {
    const [data, setData] = useState([]);
    const [form, setForm] = useState({ ...initialState });
    const [search, setSearch] = useState('');

    const [editing, setEditing] = useState(false);
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(false);

    const toast = useRef();

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
    const showSuccess = (response) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: response.data.message });

    const formatNumber = (rowData, props) => {
        if(rowData[props.field] === null)
            return 'não preenchido';
        return Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rowData[props.field]);
    }

    const fetchData = useCallback(() => {
        setLoading(true);
        api.get('residuos').then(response => {
            setLoading(false);
            setData(response.data);
        }).catch(error => {
            setLoading(false);
            setData([]);
            showError(error);
        });
    }, []);

    const handleEdit = (rowData) => {
        setEditing(true);
        setVisible(true);
        setForm({ ...rowData });
    }

    // const handleDelete = (rowData) => {
    //     confirmDialog({
    //         acceptClassName: "p-button-danger",
    //         acceptLabel: "Excluir",
    //         rejectClassName: "p-button-secondary",
    //         rejectLabel: "Cancelar",
    //         header: "Excluir",
    //         message: "Você tem certeza que deseja excluir o registro?",
    //         accept: () => {
    //             setLoading(true);
    //             api.delete(`residuos/${rowData.id}/delete`).then(response => {
    //                 fetchData();
    //                 setLoading(false);
    //                 showSuccess(response);
    //             }).catch(error => {
    //                 setLoading(false);
    //                 showError(error);
    //             });
    //         }
    //     });
    // }

    const handleSubmit = () => {
        setLoading(true);

        if (editing) {
            api.put(`residuos/${form.id}/update`, form).then(response => {
                fetchData();
                setLoading(false);
                showSuccess(response);
                onHide();
            }).catch(error => {
                setLoading(false);
                showError(error);
            });
        } else {
            api.post('residuos', form).then(response => {
                fetchData();
                setLoading(false);
                showSuccess(response);
                onHide();
            }).catch(error => {
                setLoading(false);
                showError(error);
            });
        }
    }

    const onShow = () => setVisible(true);

    const onHide = () => {
        if (editing) {
            setForm({ ...initialState });
            setEditing(false);
        }
        setVisible(false);
    }

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <div>
            <Menu />
            <Toast ref={toast} />

            {loading ? (
                <Loading />
            ) : (
                <>
                    <Dialog
                        footer={() => (
                            <div>
                                <Button
                                    className='p-button-secondary'
                                    label='Cancelar'
                                    onClick={onHide}
                                />

                                <Button
                                    className='p-button-success'
                                    label='Salvar'
                                    onClick={handleSubmit}
                                />
                            </div>
                        )}
                        header={editing ? 'Editar Registro' : 'Novo Registro'}
                        onHide={onHide}
                        visible={visible}
                    >
                        <div className='p-fluid p-grid'>
                            <div className='p-field p-col-12'>
                                <InputText
                                    onChange={e => setForm({ ...form, codigo: e.target.value })}
                                    placeholder='Exemplo: T01'
                                    value={form.codigo}
                                />
                            </div>

                            <div className='p-field p-col-12'>
                                <InputText
                                    onChange={e => setForm({ ...form, descricao: e.target.value })}
                                    placeholder='REFUGO'
                                    value={form.descricao}
                                />
                            </div>

                            <div className='p-field p-col-12'>
                                <InputText
                                    onChange={e => setForm({ ...form, perda_metragem_por_rolo: e.target.value })}
                                    placeholder='40m'
                                    type='number'
                                    value={form.perda_metragem_por_rolo}
                                />
                            </div>
                        </div>
                    </Dialog>
                    <Card
                        className='m-1'
                        title='Resíduos'
                    >
                        <div className='p-d-flex p-flex-row p-justify-between'>
                            <InputText
                                className='p-m-1'
                                onChange={e => setSearch(e.target.value)}
                                placeholder='Pesquisar...'
                                value={search}
                            />

                            <Button
                                className='p-button-success p-m-1'
                                icon='pi pi-plus'
                                onClick={onShow}
                                title='Clique para cadastrar um novo registro'
                            />
                        </div>

                        <DataTable
                            emptyMessage='Nenhum registro encontrado'
                            globalFilter={search}
                            size='small'
                            value={data}
                        >
                            <Column header='Cod Portal' field='produto_id' sortable />
                            <Column header='Cod Resíduo' field='codigo' sortable />
                            <Column header='Descrição' field='descricao' sortable />
                            <Column header='Perda por rolo (m)' field='perda_metragem_por_rolo' body={formatNumber} />
                            <Column header='Ações' body={(rowData) => (
                                <div>
                                    <Button
                                        className='p-mr-1 p-button-primary'
                                        icon='pi pi-pencil'
                                        onClick={() => handleEdit(rowData)}
                                        title='Clique para atualizar o registro'
                                    />

                                    {/* <Button
                                        className='p-mr-1 p-button-danger'
                                        icon='pi pi-trash'
                                        onClick={() => handleDelete(rowData)}
                                        title='Clique para excluir o registro'
                                    /> */}
                                </div>
                            )} />
                        </DataTable>
                    </Card>
                </>
            )}
        </div>
    )
}